import React from "react";

const PreetiToUnicode = () => {
  return (
    <div className="w-full w-padding">
      <div className="bg-primary-blue mt-10 font-Acme w-[105%] rounded-full p-1 text-center text-2xl font-semibold text-white">
        Preeti to Unicode
      </div>
      <div className="">
        <iframe
          className="h-[500px] w-full"
          title="preeti to unicode"
          src="https://www.ashesh.com.np/preeti-unicode/linkapi.php?api=330181m519"
          frameborder="0"
          scrolling="no"
          marginwidth="0"
          marginheight="0"
          allowtransparency="true"
        ></iframe>
      </div>
    </div>
  );
};

export default PreetiToUnicode;
